import { tryLoadPropertyStyles } from '../Global/loadDependecy'
import { TemplatePropertyListStyles } from './PropertyList.styles'
import type { PropertyListData } from './types/PropertyList.type'

// Remove the propertyItemTemplate - we'll use ts-property instead

const t = document.createElement('template')
t.innerHTML = `
  <div class="property-list wa-stack" part="container">
    <slot></slot>
  </div>
`

const TemplatePropertyList = t

class PropertyList extends HTMLElement {
  constructor() {
    super()
    
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplatePropertyListStyles.content.cloneNode(true))
    shadow.appendChild(TemplatePropertyList.content.cloneNode(true))

    tryLoadPropertyStyles(shadow, 'Property.css');
  }

  connectedCallback() {
    console.log('PropertyList connectedCallback')
  }

  static get observedAttributes() {
    return ['data']
  }

  attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null) {
    if (name === 'data' && newValue) {
      this.renderData(newValue)
    }
  }

  // rendered data or add your own slotted content
  private renderData(json: string) {
    let parsed: PropertyListData | null = null
    try {
      parsed = JSON.parse(json)
    } catch {
      console.warn('PropertyList: invalid JSON data')
      return
    }

    // Support nested shape { data: { properties: [...] } } as well
    const maybeNested = (parsed as any)
    if (!parsed?.properties && maybeNested?.data?.properties) {
      parsed = maybeNested.data
    }

    const container = this.shadowRoot?.querySelector('.property-list')
    if (!container) return

    // Remove previously data-driven items (keep any slotted content)
    Array.from(container.querySelectorAll('[data-generated="true"]')).forEach(el => el.remove())

    if (!parsed?.properties || parsed.properties.length === 0) return

    parsed.properties.forEach(p => {
      const item = document.createElement('ts-property')
      item.setAttribute('name', String(p.name))
      item.setAttribute('value', String(p.value))
      item.setAttribute('container-class', 'property-list wa-split')  // PropertyList uses wa-split
      item.setAttribute('container-part', 'property-list-item')  // PropertyList part name
      item.setAttribute('data-generated', 'true')
      container.appendChild(item)
    })
  }
}

if (!customElements.get('ts-propertylist')) {
  customElements.define('ts-propertylist', PropertyList)
}
export { PropertyList }
